var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1114 32.6539L32.2544 31.6344C32.5878 28.7438 34.9816 28.5363 34.9816 25.1865C34.9816 22.3239 32.6609 20.0032 29.7983 20.0032C26.9357 20.0032 24.615 22.3239 24.615 25.1865C24.615 28.5363 27.0088 28.7438 27.3422 31.6344L27.4852 32.6539M29.794 32.6539V27.2233M27.5529 34.8326H32.0437M37.3076 43.7635C36.6871 40.4159 36.6258 38.3178 39.1357 35.8283C42.5597 32.4323 43.8265 28.4696 43.8265 25.1209C43.8265 17.26 37.584 11.0186 29.7789 11.0186C23.8902 11.0186 18.1198 14.1866 16.5476 20.3033C16.2863 21.3195 16.0734 22.4121 16.1003 23.3831C16.1175 24.0079 15.9788 24.6262 15.6798 25.1747L12.0451 31.9226C11.7278 32.5108 12.0849 33.2367 12.7441 33.3453L15.8917 33.8626L16.5638 39.9373C16.695 41.1192 17.7381 41.9848 18.9231 41.8945L25.7506 41.3772C27.8444 41.2181 29.5542 39.6416 29.8811 37.5672L29.9725 36.9865M29.7951 16.8664V14.5318M35.6988 19.3129L37.3495 17.6611M38.1442 25.2166H40.4788M35.6978 31.1204L37.3495 32.7711M23.8902 31.1193L22.2385 32.7711M21.4448 25.2155H19.1092M23.8902 19.3118L22.2395 17.6611M24.4107 43.4L24.5742 45.1238M31.635 25.3263C31.635 26.3415 30.8124 27.1641 29.7972 27.1641C28.7821 27.1641 27.9594 26.3415 27.9594 25.3263",
    stroke: "#878686",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemories);
export default __webpack_public_path__ + "static/media/memories.d93a2dec5e9d94cd387a1b6f36c3a6b7.svg";
export { ForwardRef as ReactComponent };